<script>
  import { readHash, writeHash } from './query';
  import DiffSection from './components/DiffSection.svelte';
  import StyleSection from './components/StyleSection.svelte';

  let settings = readHash();

  $: if (settings) writeHash(settings);

  const handleStyleChange = event => {
    const { index, url, style } = event.detail;

    const styles = settings.styles.map((e, i) => {
      if (i !== index) return e;
      return { ...e, url, style };
    });

    settings = { ...settings, styles };
  };
</script>

<svelte:head>
  <base href=process.env.BASE_PATH>
</svelte:head>
<main>
  <StyleSection
    index={0}
    label='Before'
    styleObject={settings.styles[0].style}
    styleUrl={settings.styles[0].url}
    on:styleChange={handleStyleChange}
  />
  <StyleSection
    index={1}
    label='After'
    styleObject={settings.styles[1].style}
    styleUrl={settings.styles[1].url}
    on:styleChange={handleStyleChange}
  />
  <DiffSection
    style0={settings.styles[0].style}
    style1={settings.styles[1].style}
  />
</main>

<style>
  main {
    display: flex;
    flex-direction: row;
    height: 100%;
  }

  :global(main > section) {
    max-width: 33%;
  }
</style>
